import { render, staticRenderFns } from "./NotInterested.container.vue?vue&type=template&id=0c9146e4&scoped=true&"
import script from "./NotInterested.container.vue?vue&type=script&lang=js&"
export * from "./NotInterested.container.vue?vue&type=script&lang=js&"
import style0 from "./NotInterested.container.vue?vue&type=style&index=0&id=0c9146e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9146e4",
  null
  
)

export default component.exports